import { create } from "apisauce";

const baseURL = process.env.REACT_APP_API_PATH;

const api = create({
  baseURL,
  timeout: 30000,
});

export const manageError = (response) => {
  if (response.ok) {
    return response.data;
  } else {
    console.log(response);
    throw new Error(
      (response.data && response.data.error && response.data.error) ||
        response.problem
    );
  }
};

export default api;
